// frontend/src/pages/PrivacyPolicy.js

import React from 'react';
import { motion } from 'framer-motion';

const PrivacyPolicy = () => {
  return (
    <motion.div
      className="min-h-screen bg-gradient-to-b from-white to-gray-50 py-12 px-4"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
    >
      <div className="max-w-2xl mx-auto bg-white rounded shadow-md p-8">
        <h1 className="text-3xl font-heading text-primary mb-6">
          Datenschutzerklärung
        </h1>

        <p className="mb-4 leading-relaxed text-gray-700">
          Diese Datenschutzerklärung beschreibt, wie Entecity.ch („wir“, „uns“ oder
          „unser“) deine persönlichen Daten sammelt, nutzt und weitergibt, wenn du
          unsere Webseite und Dienstleistungen (zusammen der „Service“) besuchst
          oder nutzt. Durch die Nutzung des Services stimmst du den in dieser
          Richtlinie beschriebenen Praktiken zu.
        </p>

        <p className="mb-4 leading-relaxed text-gray-700">
          <strong>1. Welche Informationen wir sammeln</strong>
          <br />
          <em>Erhebung und Verarbeitung personenbezogener Daten</em> – Personenbezogene
          Daten werden nur im erforderlichen Umfang erhoben und verarbeitet. Dazu
          gehören insbesondere:
        </p>
        <ul className="list-disc list-inside mb-4 text-gray-700 space-y-1">
          <li>Name und E-Mail-Adresse für die Registrierung (falls erforderlich)</li>
          <li>Inhaltsbezogene Informationen im Rahmen der journalistischen Beiträge</li>
          <li>Technische Daten (z. B. IP-Adresse, Log-Dateien, Browsertyp)</li>
        </ul>

        <p className="mb-4 leading-relaxed text-gray-700">
          <strong>2. Wie wir deine Informationen nutzen</strong>
          <br />
          Wir verwenden die gesammelten Informationen, um:
        </p>
        <ul className="list-disc list-inside mb-4 text-gray-700 space-y-1">
          <li>den Service bereitzustellen, zu verwalten und zu verbessern</li>
          <li>mit dir zu kommunizieren und auf Anfragen zu reagieren</li>
          <li>die Nutzung und Trends zu analysieren</li>
          <li>die Sicherheit und Integrität des Services zu schützen</li>
        </ul>

        <p className="mb-4 leading-relaxed text-gray-700">
          <strong>3. Cookies</strong>
          <br />
          Wir verwenden Cookies und ähnliche Tracking-Technologien, um deine
          Erfahrung auf dem Service zu verbessern, die Nutzung zu analysieren und
          Inhalte anzupassen. Du kannst deinen Browser so einstellen, dass er alle
          Cookies ablehnt oder dich benachrichtigt, wenn ein Cookie gesendet wird.
          Falls du Cookies ablehnst, können gewisse Funktionen unseres Services
          möglicherweise nicht genutzt werden.
        </p>

        <p className="mb-4 leading-relaxed text-gray-700">
          <strong>4. Weitergabe deiner Informationen</strong>
          <br />
          Wir verkaufen oder vermieten deine persönlichen Daten nicht an Dritte.
          Allerdings können wir sie mit vertrauenswürdigen Drittanbietern teilen,
          die uns bei der Bereitstellung des Services unterstützen, sofern sie sich
          verpflichten, deine Daten vertraulich zu behandeln. Zudem können wir
          deine Informationen weitergeben, wenn dies gesetzlich vorgeschrieben ist
          oder auf berechtigte Anfragen öffentlicher Behörden hin.
        </p>

        <p className="mb-4 leading-relaxed text-gray-700">
          Nutzer haben zudem folgende Rechte bezüglich ihrer personenbezogenen Daten:
        </p>
        <ul className="list-disc list-inside mb-4 text-gray-700 space-y-1">
          <li>Recht auf Auskunft (§ 15 DSGVO)</li>
          <li>Recht auf Berichtigung (§ 16 DSGVO)</li>
          <li>Recht auf Löschung (§ 17 DSGVO)</li>
          <li>Recht auf Einschränkung der Verarbeitung (§ 18 DSGVO)</li>
          <li>Recht auf Datenübertragbarkeit (§ 20 DSGVO)</li>
          <li>Recht auf Widerspruch gegen die Verarbeitung (§ 21 DSGVO)</li>
        </ul>

        <p className="mb-4 leading-relaxed text-gray-700">
          <strong>5. Datensicherheit</strong>
          <br />
          Wir ergreifen angemessene Massnahmen, um deine persönlichen Daten vor
          unbefugtem Zugriff, Änderung, Offenlegung oder Zerstörung zu schützen.
          Dennoch ist keine Übertragung über das Internet oder elektronische
          Speicherung zu 100 % sicher, und wir können keine absolute Sicherheit
          garantieren.
        </p>

        <p className="mb-4 leading-relaxed text-gray-700">
          <strong>6. Internationale Datenübertragungen</strong>
          <br />
          Deine Daten können auf Servern ausserhalb deines Kantons oder Landes
          gespeichert und verarbeitet werden. Wir treffen alle zumutbaren
          Vorkehrungen, um sicherzustellen, dass deine Daten sicher und gemäss
          dieser Datenschutzerklärung behandelt werden.
        </p>

        <p className="mb-4 leading-relaxed text-gray-700">
          <strong>7. Datenschutz von Kindern</strong>
          <br />
          Wir sammeln nicht bewusst personenbezogene Daten von Kindern unter 13
          Jahren. Falls du als Elternteil oder Erziehungsberechtigter vermutest,
          dass dein Kind uns personenbezogene Daten übermittelt hat, kontaktiere
          uns bitte, damit wir die notwendigen Schritte zur Löschung dieser Daten
          unternehmen können.
        </p>

        <p className="mb-4 leading-relaxed text-gray-700">
          <strong>8. Änderungen dieser Datenschutzerklärung</strong>
          <br />
          Wir können diese Datenschutzerklärung von Zeit zu Zeit aktualisieren.
          Änderungen werden durch die Veröffentlichung der neuen Version auf dieser
          Seite und einem aktualisierten „Zuletzt aktualisiert“-Datum bekannt
          gegeben. Deine fortgesetzte Nutzung des Services nach solchen Änderungen
          gilt als Zustimmung zur neuen Datenschutzerklärung.
        </p>

        <p className="mb-4 leading-relaxed text-gray-700">
          <strong>9. Kontakt</strong>
          <br />
          Falls du Fragen zu dieser Datenschutzerklärung hast, kannst du uns
          mittels der Kontaktdaten im Impressum kontaktieren.
        </p>
      </div>
    </motion.div>
  );
};

export default PrivacyPolicy;
